import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";

import { Link } from "react-router-dom";

import { Typography } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import { Badge } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import StorefrontIcon from "@mui/icons-material/Storefront";
const useStyles = makeStyles({
  title: {
    fontWeight: "bold",
    paddingLeft: "40px",
    fontSize: "18px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  leftmenu: {
    border: "1px solid lightgray",
    borderRadius: "5px",
    lineHeight: "2.5em",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  each: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "33px",
  },
  each_cursor: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    paddingLeft: "33px",
    // borderRight: "10px solid #78909c",
  },
});

const DashboardMenu = ({ page }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.leftmenu}>
        <Box className={classes.title}>
          <StorefrontIcon
            sx={{ position: "relative", top: "+4px", left: "-10px" }}
          />
          Admin Account
        </Box>
        <Box></Box>
        {page === "profile" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/dashboard">Dashboard</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/dashboard">Dashboard</Link>
            </Box>
          </Box>
        )}
        {page === "orders" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/orders">Orders</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/orders">Orders</Link>
            </Box>
          </Box>
        )}
        {page === "finance" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/finance">Finance</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/finance">Finance</Link>
            </Box>
          </Box>
        )}
        {page === "products" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box
              sx={{
                pt: 1,
                pl: 1,
              }}
            >
              <Link to="/admin/products">Products</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box
              sx={{
                pt: 1,
                pl: 1,
              }}
            >
              <Link to="/admin/products">Products</Link>
            </Box>
          </Box>
        )}
        {page === "add-product" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/add-products">Add Product</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/add-products">Add Product</Link>
            </Box>
          </Box>
        )}
        {/* {page === "password" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-password">Change Password</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-password">Change Password</Link>
            </Box>
          </Box>
        )} */}
        {page === "reviews" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/reviews">Manage Reviews</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/admin/reviews">Manage Reviews</Link>
            </Box>
          </Box>
        )}
        {page === "communication" ? (
          <Box className={classes.each_cursor}>
            <Badge
              color="secondary"
              overlap="circular"
              variant="dot"
              sx={{ position: "relative", left: "-20px" }}
            ></Badge>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/communication">Communication</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/communication">Communication</Link>
            </Box>
          </Box>
        )}
      </Box>
      <Box
        className={classes.leftmenu}
        sx={{ mt: 4, px: 3, lineHeight: "1.8em", color: "#9e9e9e", pb: 3 }}
      >
        <Box sx={{ position: "relative", top: "+20px" }}>
          <AdminPanelSettingsIcon sx={{ color: "#36b4e6" }} />
        </Box>
        <Typography sx={{ pt: 2, pb: 2 }}>Your Privacy</Typography>
      </Box>
    </>
  );
};

export default DashboardMenu;
